import {
  Fieldset,
  FieldsetLegend,
} from "@imi/ui/components/Fieldset/Fieldset.js";
import { UnitsOptions } from "@src/core/engine/units/unitsRepository";
import { useTranslation } from "react-i18next";
import { useUnitsForm } from "../hooks/useUnitsForm";

type PowerProps = {
  form: ReturnType<typeof useUnitsForm>["form"];
  unitsOptions: UnitsOptions;
};

export function Power({ form, unitsOptions }: PowerProps) {
  const { t } = useTranslation("settings", { keyPrefix: "units" });

  return (
    <Fieldset>
      <FieldsetLegend>{t("power.title")}</FieldsetLegend>
      <form.AppField name="electricalPower">
        {(field) => (
          <field.Select label={t("power.fields.electricalPower")}>
            {unitsOptions.electricalPower.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="energy">
        {(field) => (
          <field.Select label={t("power.fields.energy")}>
            {unitsOptions.energy.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>
    </Fieldset>
  );
}
